// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, ".wxc-generic-modal__container {\n  align-items: unset;\n}", "",{"version":3,"sources":["webpack://./src/packages/widgets/src/components/GenericModal/GenericModal.styles.scss"],"names":[],"mappings":"AAGE;EACE,kBAAA;AAFJ","sourcesContent":["$C: wxc-generic-modal;\n\n.#{$C} {\n  &__container {\n    align-items: unset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
export default ___CSS_LOADER_EXPORT___;
